<script>
export default {
  name: 'PageHeader',
  props: {
    heading: String,
    nr: Number
  },
  methods: {
    onExitStationClick() {
      this.$store.dispatch('exitStation')
    }
  }
};
</script>

<template>
  <header class="page-header">
    <h1 class="page-header__title">
      {{heading}}
    </h1>
  </header>
</template>

<style scoped lang="scss">
@import '../assets/styles/variables';
@import '../assets/styles/common';

.page-header {
  padding: 1em 0;
  background: var(--light, white);
}

.page-header__title {
  margin: 0;
  font-size: 1.5rem;
  text-align: center;
}

</style>
